import { render, staticRenderFns } from "./gc-popup-link-an-item.vue?vue&type=template&id=929e68f0&"
import script from "./gc-popup-link-an-item.vue?vue&type=script&lang=js&"
export * from "./gc-popup-link-an-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports